import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { Widget } from '~/components/MyWorkspace/Widget';
import { useSelectedLanguageContext } from '~/components/SelectedLanguage';
import { TaskStatusEnum } from '~/services/Http/client.people.generated';
import { useGetTeamWorklists } from '~/services/Http/hooks';

import { WidgetProps } from '../../data/widgets';

import { MyTeamWorklistsWidgetComponent } from './components/MyTeamWorklistsWidgetComponent';
import { useSxStyles } from './useStyles';

export interface Props extends WidgetProps {}

export const getTeamWorklistsReqParams = {
  employeeId: 'me',
  statuses: [
    TaskStatusEnum.NEW,
    TaskStatusEnum.IN_PROGRESS,
    TaskStatusEnum.SKIPPED,
  ],
};

export const MyTeamWorklistsWidget: React.FC<Props> = ({ config }) => {
  const sxStyles = useSxStyles();
  const { t } = useTranslation();
  const { language } = useSelectedLanguageContext();

  const {
    data: worklistData,
    loading,
    failedToLoad,
    mutate: mutateMyTeamWorklists,
  } = useGetTeamWorklists({
    ...getTeamWorklistsReqParams,
    roles: config?.role ? [config.role.toString()] : undefined,
    lang: language,
  });

  if (!config?.role) {
    return <div>{t('noDataAvailable')}</div>;
  }

  return (
    <Widget
      title={t('teamTasklists')}
      content={
        <MyTeamWorklistsWidgetComponent
          worklistData={worklistData}
          isLoading={loading}
          failedToLoad={failedToLoad}
          role={config?.role}
          mutateMyTeamWorklists={mutateMyTeamWorklists}
        />
      }
      customSxStyles={{ actions: sxStyles.widgetActions }}
      dataCy="my-team-worklists-widget"
    />
  );
};
